import * as React from "react";

import { Button } from "src/components/buttons";

import CoreAPI from "src/core/CoreAPI";
import ReportAPI from "src/admin/report/ReportAPI";
import LocationAPI from "src/admin/Organization/Location/LocationAPI";
import FullReportTemplate from "./templates/v1/FullReportTemplate";

import PickListContext from "src/context/pickListContext";
import { Page, Spinner } from "src/components/common";
import { notifyV1ReportsNotSupported } from "src/components/common/V1ReportsNotSupported";

interface IProps {
	location?: any;
	match: any;
}

interface IState {
	report: ReportNecessaryInfoDTO;
	coreTestResult: CoreTestResultDTO;
	coreErrorEntries: CoreErrorEntryDTO[];
	coreEvaluatorName: string;
	reportSetting: ReportSettingDTO;
	clientInfo: ClientDTO;
	locations: LocationDTO[];
	vitalsTestResult: VitalsTestResultDTO;
	vitalsToplots: VitalsToplotsDTO;
	vitalsSubScores: VitalsSubScoresDTO;
	vitalsCompletedTasks: VitalsCompletedTasksDTO[];
	vitalsEvaluatorName: string;
	fileURL: string;
	showFileLink: boolean;
	isLoading: boolean;
}

class ReportTemplateContainer extends React.Component<IProps, IState> {
	public static contextType = PickListContext;

	constructor(props: any) {
		super(props);
		this.state = {
			report: {},
			clientInfo: {},
			reportSetting: {},
			locations: [],
			coreTestResult: {},
			coreErrorEntries: [],
			coreEvaluatorName: "",
			vitalsTestResult: {},
			vitalsToplots: {},
			vitalsSubScores: {},
			vitalsCompletedTasks: [],
			vitalsEvaluatorName: "",
			isLoading: false,
			fileURL: "",
			showFileLink: false,
		};
	}

	public componentDidMount() {
		this.loadTestResult();
	}

	public render() {
		if (this.state.isLoading) {
			return <Spinner size="full-page" />;
		}
		return (
			<Page title="Report">
				<div className="container-fluid">
					{this.renderFullTemplate()}
					<div className="d-flex flex-row-reverse no-print">
						<Button
							className="btn-primary mr-3 no-print"
							onClick={this.printPDF}
						>
							Print Report
						</Button>
						<Button
							className="btn-primary mr-3 no-print"
							onClick={this.generatePDF}
						>
							Generate PDF
						</Button>
					</div>
				</div>
			</Page>
		);
	}

	private loadTestResult = () => {
		const { reportId } = this.props.match.params;
		this.setState({ isLoading: true });
		ReportAPI.getReport({ reportId })
			.then((res) =>
				this.setState({
					report: res,
				})
			)
			.then(() =>
				ReportAPI.getReportSettings({ reportId }).then((res) =>
					this.setState({
						reportSetting: res,
					})
				)
			)
			.then(() =>
				LocationAPI.getOrganizationLocations(
					this.state.clientInfo.organizationId!
				)
			)
			.then((orgLocations) => this.setState({ locations: orgLocations }))
			.then(() => {
				if (this.state.report.coreTestResultId) {
					// don't refactor this method because it will check current user's permission and match userId with evaluatorId on back-end
					ReportAPI.getCoreTestForReport({
						reportId: this.state.report.assessmentResultId,
						coreTestResultId: this.state.report.coreTestResultId,
					})
						.then((res) => this.setState({ coreTestResult: res }))
						.then(() =>
							CoreAPI.getClientCoreErrorEntries({
								coreTestResultId: this.state.report.coreTestResultId,
							})
						)
						.then((res) =>
							this.setState({ coreErrorEntries: res, isLoading: false })
						);
				}
			})
			.then(() => {
				if (this.state.report.vitalsTestResultId) {
					ReportAPI.getVitalsTestForReport({
						reportId: this.state.report.assessmentResultId,
						vitalsTestResultId: this.state.report.vitalsTestResultId,
					})
						.then((res) => this.setState({ vitalsTestResult: res }))
						.then(() =>
							ReportAPI.getVitalsFactorsForReport({
								reportId: this.state.report.assessmentResultId,
								vitalsTestResultId: this.state.report.vitalsTestResultId,
							})
						)
						.then((res) =>
							this.setState({
								vitalsSubScores: res.vitalsSubScores!,
								vitalsToplots: res.vitalsToplots!,
								vitalsCompletedTasks: res.vitalsCompletedTasks!,
								isLoading: false,
							})
						);
				}
			});
	};

	private generatePDF = async () => {
		// V1 (HTML-to-PDF) report generation was retired.
		notifyV1ReportsNotSupported();
	};

	// TODO: why pass in picklistitems? use context?
	private renderFullTemplate = () => {
		return (
			<Page>
				<FullReportTemplate
					report={this.state.report}
					reportSetting={this.state.reportSetting}
					locations={this.state.locations}
					coreTestResult={this.state.coreTestResult}
					coreErrorEntries={this.state.coreErrorEntries}
					vitalsTestResult={this.state.vitalsTestResult}
					vitalsToplots={this.state.vitalsToplots}
					vitalsSubScores={this.state.vitalsSubScores}
					vitalsCompletedTasks={this.state.vitalsCompletedTasks}
				/>
			</Page>
		);
	};

	private printPDF = () => {
		window.print();
	};
}

export default ReportTemplateContainer;
